import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { ABORTABLE_PROVIDER } from './actions.js';

var abortMiddleware = function abortMiddleware() {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === "function" || action.type !== ABORTABLE_PROVIDER) {
          return next(action);
        }

        var abort = action.abort,
            abortAction = action.action;

        if (typeof abortAction === "function") {
          // thunks can't be handled automatically
          // the abort implementation will however be available as a 3rd param
          return abortAction(dispatch, getState, abort);
        }

        var abortableAction = _objectSpread2(_objectSpread2({}, abortAction), {}, {
          abort: abort
        });

        return dispatch(abortableAction);
      };
    };
  };
};

var abortMiddleware$1 = abortMiddleware;

export { abortMiddleware$1 as default };
